import styled from 'styled-components';

interface PageWrapperProps {
  $paddingBottom?: number | null;
}

export const PageWrapper = styled.div<PageWrapperProps>`
  ${({ $paddingBottom }) => $paddingBottom != null && `padding-bottom: ${$paddingBottom}px;`}
`;
